import React from 'react'
import './Airfreight.css'
function Airfreight() {
  return (
      <div className="airfreight-services-container">
      {/* Hero section with image and overlay text */}
      <div className="airfreight-services-hero">
        <div className="airfreight-services-overlay">
          <h1>Air Freight</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
       {/* Content section with image and text */}
      <div className="airfreight-content">
        <div className="airfreight-image">
          <img src="/Pics/airfreight.jpg" alt="Full Logistics Services" />
        </div>
        
        <p>
        Centrex marine services considers speed and punctuality the most crucial aspects of air freight forwarding. This understanding ensures the mely and secure delivery of cargo while priorizing its safety at the company. We, along with our team of experts, are well-versed in meeng the demands of supply chains with precision and professionalism through precise air freight forwarding.
        </p>
        
        <p>
          Our well-established connecons with respected global air carriers foster a direct pathway to more favorable fares and increased cargo capacity, guaranteeing exceponal service to our patrons.
        </p>
        
        <p>
         Disnguished by its airfare administraon, Centrex marine services’s influence connues to grow. Grasping the value of me in global commerce, we cater tailored air logiscs services at reasonable costs.
        </p>
        
        <p>
         Our worldwide reach enables us to provide a broad array of specialist air freight soluons, encompassing imports & exports across diverse categories like perishables, dangerous goods, heavy machinery, and giant consignments. By forming lasng alliances with reputable airlines, we guarantee hassle-free customs procedures and mely arrival of valued commodies.
        </p>
        
        <p>
         Fostering a culture of punctuality within our organizaon has become more vital than ever since many clients need to necessitate quickly moving cargo via air transit — entrust us with yours today! By forming inial relaonships beforehand, we guarantee the quick transfer and transportaon of products along the fastest trajectories available.
        </p>
        
        <p>
        Providing full support during all stages of shipping, including reservaon, transferring goods via express transport; customs release; and final delivery upon reaching the desnaon which we refer to as Door Door.
        </p>

        <p>
       Given the rising trend in air freight movements, we aspire to capture a larger share of this business in Pakistan. There are limited goods forwarders handling air freight in the country, and Centrex marine services stands as one of them.
        </p>   
        
        <p>
        We are dedicated to delivering superior service quality and expanding our customer network through exceponal performance. Our teams are readily accessible at all mes, and we are eager to offer soluons for the mely import and export of your products.
        </p>
      </div>
      </div>
  )
}

export default Airfreight